<ng-content select="input[valgInput]"></ng-content>
<button type="button" valgButton class="valg-form-password__button" (blur)="blurButton($event)" (click)="togglePasswordState()" [attr.aria-pressed]="showPassword" [attr.aria-controls]="inputElement.getAttribute('id')" [attr.title]="buttonText | translate">
  <mat-icon [svgIcon]="showPassword ? SvgIcon.EyeClose: SvgIcon.EyeOpen"></mat-icon>
  <span class="sr-only">{{ buttonText | translate }}</span>
</button>
